import LazyLoad from "vanilla-lazyload";

export default function lazyImg() {

    const lazyLoad = new LazyLoad({
        elements_selector: "img.lazyload"
    });

    lazyLoad.loadAll(); // если нужно форсить загрузку
}